// extracted by mini-css-extract-plugin
module.exports = {"featuredHeader":"FeaturedHeader_featuredHeader__QJnVG","header":"FeaturedHeader_header__1L_Fc"};